import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import '@adornis/chemistry/elements/components/x-flex';
import { routingState } from '@adornis/router/client/routing-state.js';
import { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html } from 'lit';
import { state } from 'lit/decorators.js';
import type { DlaTranslationDict } from '../translations.js';

/*
 * @element dla-imprint
 */
export class DlaFooterPage extends ChemistryLitElement {
  @state() _translator = new TranslationController<DlaTranslationDict>(this);
  @state() _moodleMode = new RXController(this, routingState.value.searchParams.get('moodleMode'));

  protected backButton() {
    if (this._moodleMode.value === '1') {
      return html`
        <x-button @click=${() => history.back()}> ${this._translator.translate('button', 'back')} </x-button>
      `;
    }
  }
}
